export const VoidBtnModuleArr=[
    "skil_solution_examine",//预算报价
    "bid_offer_examine",//投标报价
    "visa_examine",//甲方签证

    "project_presentation_examine",// 项目交底
    "project_work_examine",// 开工报告
    "project_work_log_examine",// 施工日志
    "purchase_contract_settle",//采购合同结算记录
    "subcontract_settle_examine",//分包结算
    "project_lease_settlement_examine",//租赁结算
    "settlement_examine",//产值结算管理
    // "progress_write_examine",//进度填报
    "travel_record_apply_examine",//出差申请
]
export const changeBtnModuleArr=[
    "project_work_budget_examine",//施工预算
    "project_work_plan_examine",//施工计划
    "project_examine", // 项目登记
]
// 项目状态已关闭不显示流程按钮
export const FlowBtnVisibleByProject=[
    "project_examine",//项目登记
    "bid_examine",//投标申请
    "bid_opening_examine",//开标管理
    "contract_examine",//工程合同
    "work_set_up_examine",//施工立项
    "completion_acceptance_examine",//竣工验收
]
// 合同状态已终止不显示流程按钮
export const FlowBtnVisibleByContract:string[]=[
    "contract_examine", // 工程合同  //没有传合同yzz的statuKey
    "purchase_contract_examine", // 采购合同
    "subcontract_examine", // 分包合同
    "contract_of_tenancy_examine", // 租赁合同
]
// 应收款状态取消收款，完成收款不显示流程按钮
export const FlowBtnVisibleByPayment:string[]=[
    "receipt_examine",//合同收款单
    "margin_return_examine",//保证金退回
]
// 应付款状态取消付款，完成付款不显示流程按钮
export const FlowBtnVisibleByPaymentMoney:string[]=[
    "purchase_payment_apply_examine",//采购付款申请
    "subcontract_payment_apply_examine",//分包付款申请
    "lease_payment_apply_examine", // 租赁付款申请
    "expense_account_examine",//费用报销
    "invite_bid_file_examine",//投标报名费
    "assuring_money_examine",//保证金申请
    "payment_order_external_examine",//对外付款单
    "margin_payment_examine",//保证金支付
]
// 开票状态取消开票，完成开票不显示流程按钮
export const FlowBtnVisibleByMakeTicket:string[]=[
    "invoice_application_examine", // 开票申请
    "make_invoice_examine", // 开票管理
]
// 收票状态取消收票，完成收票不显示流程按钮
export const FlowBtnVisibleByIncomeTicket:string[]=[
    "income_invoice_examine", // 收票管理
]
